import React from 'react';
import { Link } from 'react-router-dom';
import ScreenshotFrame from './ScreenshotFrame';
import { Facts, MoneyFlow, Pipeline, StatusBadge } from './Ledger';
import '../styles/Flagship.css';

// Two-column flagship row: text on one side, the lead screenshot on the other.
const Flagship = ({ study, reversed = false, condensed = false, headingLevel = 'h2' }) => {
  const { flagship } = study;
  const Heading = headingLevel;

  return (
    <article
      className={`flagship${reversed ? ' is-reversed' : ''}${condensed ? ' is-condensed' : ''}`}
      aria-labelledby={`flagship-${study.slug}`}
    >
      <div className="flagship-text">
        <span className="label label-accent">{flagship.label}</span>
        <StatusBadge status={flagship.badge} />
        <Heading id={`flagship-${study.slug}`} className="flagship-title">
          {study.title}
        </Heading>
        <p className="flagship-line">{flagship.line}</p>
        {study.moneyFlow ? (
          <MoneyFlow steps={study.moneyFlow} />
        ) : (
          <Pipeline steps={study.architecture} label="Trading pipeline" />
        )}
        <Facts facts={flagship.facts} />
        <Link to={`/projects/${study.slug}`} className="text-link">
          Read the case study <span className="arrow" aria-hidden="true">→</span>
        </Link>
      </div>
      <div className="flagship-media">
        <ScreenshotFrame slug={study.slug} screenshot={study.screenshots[0]} />
      </div>
    </article>
  );
};

export default Flagship;
